import React, { Component } from 'react'
import Button from '../uiKit/Button'
import Icon from '../misc/Icons'



class DowngradeCouponModal extends Component {
  	
	constructor(){
		super()
   		this.claimCoupon=this.claimCoupon.bind(this)
		this.state={
        	submitLoading:false,  
		}
	}
	 
	componentDidMount(){
		if(window.analytics){
			const {userSegment}=this.props
			let couponName='BTS2019-ActiveYearlyPro'
			if(userSegment==='activeMonthlyPro'){
				couponName='BTS2019-ActiveMonthlyPro'
			}
			window.analytics.page('Downgrade Coupon Modal',{couponName:couponName})
		}
	}

	claimCoupon(){
		this.setState({submitLoading:true})
		this.props.claimCoupon()
		
	}



	render() {
		const {userSegment}=this.props
		const {submitLoading} = this.state
		const activeMonthlyPro = userSegment==='activeMonthlyPro'
		const activeYearlyProNo2019Coupon = userSegment === 'activeYearlyProNo2019Coupon'

		return (
			<div className='downgradeModal downgradeModal--coupon'>   
				
				

				{activeMonthlyPro && 

					<div className='downgradeModal downgradeModal--coupon-inner'>  						
						
						<div className='downgradeModal--coupon-limitedOfferSash'>
							Limited-Time Offer							
							<svg width="220" height="24" viewBox="0 0 220 24">
								<path d="M2.34786499,0 L217.944529,0 C219.114074,1.93250835e-14 220.062177,0.948102883 220.062177,2.11764706 C220.062177,2.49520824 219.961233,2.86590384 219.769802,3.19133674 L215.219817,10.9263103 C214.829985,11.5890261 214.829985,12.4109739 215.219817,13.0736897 L219.769802,20.8086633 C220.362784,21.8167334 220.026289,23.114643 219.018219,23.7076254 C218.692786,23.8990565 218.322091,24 217.944529,24 L2.23732167,24 C1.0677775,24 0.119674613,23.0518971 0.119674613,21.8823529 C0.119674613,21.5138253 0.215848226,21.1516774 0.398689135,20.8317058 L5.0286337,12.7293028 C5.41031166,12.0613664 5.39973605,11.2389762 5.00100834,10.5810755 L0.536857817,3.21522716 C-0.0693189361,2.21503552 0.250093242,0.91281664 1.25028489,0.306639886 C1.58125192,0.106053807 1.96085859,9.59270341e-16 2.34786499,0 Z"/>
							</svg>							
						</div>

						<div className='downgradeModal-h1'>
							 Your Plickers Pro subscription <br/> can be <b>45% cheaper!</b>
						</div>
						<div className='downgradeModal-h3'>
							 We can't wait to show you what's coming to Pro in 2019/2020
						</div>
						<div className='downgradeModal-h2'>
							  Our back-to-school offer: <br/>Switch to annual plan today and save $50.
						</div>

						<div className='downgradeModal--coupon-btnContainer'>
							<button className='btn downgradeModal-primaryButton' disabled={submitLoading} onClick={this.claimCoupon} >
								 {!submitLoading &&
									<React.Fragment>
										<div className='downgradeModal-primaryButton-headline'>
											I'll take the offer, switch to an annual plan, and save 45%
										</div>
									 	<div className='downgradeModal-primaryButton-subline'>
									 		At the start of your next billing period, you will be charged $57.50.									 		
									 	</div>
									 	<div className='downgradeModal-primaryButton-subline'>
											Annual savings vs. monthly are $50.38 (46.7%). Discounted rate continues through 12 months.
									 </div>									 
									</React.Fragment>
								}

								 {submitLoading &&
										<div className='downgradeModal-primaryButton-submitLoading'>							 								 	
										 	<div className='downgradeModal-primaryButton-submitLoading-spinnerContainer'>
										 		<div className='downgradeModal-primaryButton-submitLoading-spinner' />
										 	</div>
										</div>
								}
							</button>
							<Button name='downgradeModalSecondary' color='white' size='large' label='No thanks, continue to Downgrade' onClickFunction={this.props.showDowngradeModal}/>
						</div>
					</div>

				}

				{activeYearlyProNo2019Coupon &&

					<div className='downgradeModal downgradeModal--coupon-inner'>  						
						
						<div className='downgradeModal--coupon-limitedOfferSash'>
							Limited-Time Offer							
							<svg width="220" height="24" viewBox="0 0 220 24">
								<path d="M2.34786499,0 L217.944529,0 C219.114074,1.93250835e-14 220.062177,0.948102883 220.062177,2.11764706 C220.062177,2.49520824 219.961233,2.86590384 219.769802,3.19133674 L215.219817,10.9263103 C214.829985,11.5890261 214.829985,12.4109739 215.219817,13.0736897 L219.769802,20.8086633 C220.362784,21.8167334 220.026289,23.114643 219.018219,23.7076254 C218.692786,23.8990565 218.322091,24 217.944529,24 L2.23732167,24 C1.0677775,24 0.119674613,23.0518971 0.119674613,21.8823529 C0.119674613,21.5138253 0.215848226,21.1516774 0.398689135,20.8317058 L5.0286337,12.7293028 C5.41031166,12.0613664 5.39973605,11.2389762 5.00100834,10.5810755 L0.536857817,3.21522716 C-0.0693189361,2.21503552 0.250093242,0.91281664 1.25028489,0.306639886 C1.58125192,0.106053807 1.96085859,9.59270341e-16 2.34786499,0 Z"/>
							</svg>							
						</div>

						<div className='downgradeModal-h1'>
							 Keep your Plickers Pro <br/> subscription and <b>save 20%!</b>
						</div>
						<div className='downgradeModal-h3'>
							 We can't wait to show you what's coming to Pro in 2019/2020.
						</div>
						<div className='downgradeModal-h2'>
							 Our back-to-school-offer: <br/> Keep your annual plan and save 20%
						</div>

						<div className='downgradeModal--coupon-btnContainer'>
							<button className='btn downgradeModal-primaryButton' disabled={submitLoading} onClick={this.claimCoupon} >
								{!submitLoading &&
									<React.Fragment>
										<div className='downgradeModal-primaryButton-headline'>
											I'll take the offer, keep my annual plan, and save 20%
										</div>
									 	<div className='downgradeModal-primaryButton-subline'>
									 		At the start of your next billing period, you will be charged $57.50.
									 	</div>
									 	<div className='downgradeModal-primaryButton-subline'>
											Savings with coupon are $14.38 (20%). Discounted rate continues through 12 months. 
									 </div>
									</React.Fragment>
								}

								 {submitLoading &&
										<div className='downgradeModal-primaryButton-submitLoading'>							 								 	
										 	<div className='downgradeModal-primaryButton-submitLoading-spinnerContainer'>
										 		<div className='downgradeModal-primaryButton-submitLoading-spinner' />
										 	</div>
										</div>
								}
							</button>
							<Button name='downgradeModalSecondary' color='white' size='large' label='No thanks, continue to Downgrade' onClickFunction={this.props.showDowngradeModal}/>
						</div>
					</div>

				}


				<div className='downgradeModal--coupon-holes downgradeModal--coupon-holes--left'>
					<Icon name='voucherSide'/>
				</div>
				<div className='downgradeModal--coupon-holes downgradeModal--coupon-holes--right'>
					<Icon name='voucherSide'/>
				</div>
			</div>

		)
	}
}


export default DowngradeCouponModal


// {currentSummerCoupon && 

// 					<div className='downgradeModal downgradeModal--coupon-inner'>  						
// 						<div className='downgradeModal-h1'>
// 							 {userFirstName}, get the summer for <b>free</b>
// 						</div>
// 						<div className='downgradeModal-h3'>
// 							 We’ve just released new Sharing features for Plickers Pro teachers, and we’d love for you to be able to try them out.
// 						</div>
// 						<div className='downgradeModal-h2'>
// 							 So we’re offering you a voucher to keep your Pro account for free until September 15th.
// 						</div>

// 						<div className='downgradeModal--coupon-btnContainer'>
// 							<button className='btn downgradeModal-primaryButton' disabled={submitLoading} onClick={this.claimCoupon} >
// 								{!submitLoading &&
// 									<React.Fragment>
// 										<div className='downgradeModal-primaryButton-headline'>
// 											I'll take it. Give me the summer for free!
// 										</div>
// 									 	<div className='downgradeModal-primaryButton-subline'>
// 									 		You will not be charged over the summer.
// 									 	</div>
// 									 	<div className='downgradeModal-primaryButton-subline'>
// 											You’ll be able to cancel for free anytime before September 15th.
// 									 </div>
// 									</React.Fragment>
// 								}

// 								 {submitLoading &&
// 										<div className='downgradeModal-primaryButton-submitLoading'>							 								 	
// 										 	<div className='downgradeModal-primaryButton-submitLoading-spinnerContainer'>
// 										 		<div className='downgradeModal-primaryButton-submitLoading-spinner' />
// 										 	</div>
// 										</div>
// 								}
// 							</button>
// 							<Button name='downgradeModalSecondary' color='white' size='large' label='No thanks, continue to Downgrade' onClickFunction={this.props.showDowngradeModal}/>
// 						</div>
// 					</div>

// 				}





// WEBPACK FOOTER //
// ./src/components/account/DowngradeCouponModal.js